/**
 * The empty state docs/design/style-guide.md requires for every list, board,
 * and report: what would fill the view, in place of a panel that just looks
 * broken with nothing in it.
 */
export default function EmptyState({ children }: { children: string }) {
  return <p className="px-4 py-6 text-center text-small text-ink-muted">{children}</p>
}
